import { Injectable } from '@angular/core';
import { Domain } from '@services/public';
import { skillUID } from 'jakapa-utilities-lite';
import { ImageChartEntry } from './common';

export interface LeaderReportAPIResponseStrengthsAndWeaknesses {
	skillUID: skillUID;
	score: number;
}

@Injectable({
	providedIn: 'root',
})
export class LeaderReportStrengthsAndWeaknessesService {
	constructor() {}

	generateReport(
		data: Array<LeaderReportAPIResponseStrengthsAndWeaknesses>,
		domain: Domain,
	): Array<ImageChartEntry> {
		const report: Array<ImageChartEntry> = [];
		for (const skill of Object.values(domain.skills)) {
			const score = data.find((data) => data.skillUID === skill.uid)?.score;
			if (typeof score !== 'number') {
				report.push({ name: skill.name, image: 'graph-insufficient1.svg' });
			} else if (score <= 3) {
				report.push({ name: skill.name, image: 'graph-improvement.svg' });
			} else if (score <= 4) {
				report.push({ name: skill.name, image: 'graph-ok.svg' });
			} else report.push({ name: skill.name, image: 'graph-good.svg' });
		}
		return report;
	}
}
